import config from 'config';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const Send = ({ coin }: any) => {
  const dispatch = useAppDispatch();
  const [password, setPassword] = useState('');
  const [amount, setAmount] = useState('');
  const [receiver, setReceiver] = useState('');

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/sendToAddress`, true).post({
      address: receiver,
      amount: amount,
      coin: coin,
      password: password,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login loginAuto'>
      <div className='inputLogin'>
        <span>Amount ({coin})</span>
        <input type='text' onChange={(e) => setAmount(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Receiver Address</span>
        <input type='text' onChange={(e) => setReceiver(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Password</span>
        <input type='password' onChange={(e) => setPassword(e.target.value)} />
      </div>
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default Send;
